import { FC } from 'react'
import s from './SkeletonCard.module.scss'
const SkeletonCard: FC = () => {
  return (
    <li className={s.root}>
      <div className={s.image}></div>
      <div className={s.title}></div>
    </li>
  )
}

export default SkeletonCard
